import 'flickity/dist/flickity.pkgd'
import vidim from 'vidim/dist/vidim'

window.vidim = vidim

const splashSlider = jQuery('.slide__holder'),
    splashSlides = jQuery('.slide__holder .slide')

let splashVideoPrev

if (splashSlider.length > 0 && splashSlides.length > 1) {

    splashSlider.flickity({
        cellSelector: '.slide',
        prevNextButtons: true,
        autoPlay: false,
        wrapAround: true,
        pageDots: true,
        cellAlign: 'left',
        arrowShape: {
            x0: 10,
            x1: 60, y1: 50,
            x2: 65, y2: 45,
            x3: 20
        },
        //setGallerySize: false,
    })

    setTimeout(function () {
        splashSlider.flickity('select', 0)
    }, 3000)

    let splashSliderData = splashSlider.data('flickity')

    splashSlider.on('select.flickity', function () {
        if (splashVideoPrev !== undefined) {
            splashVideoPrev.pause()
        }

        if (jQuery(splashSliderData.selectedElement).hasClass('slide--video')) {

            splashVideoPrev = window[`slide${splashSliderData.selectedIndex}`]
            window[`slide${splashSliderData.selectedIndex}`].play()

        }
    })
}
